<template>
  <div>
    <div>
      <div class="profile__edit--feedback error" :class="{ open: errorNotification.show }">
        {{ $t(errorNotification.message) }}
        <span class="glicon-close-large error-close" @click="close"> </span>
      </div>

      <div class="profile__edit--feedback" :class="{ open: successNotification.show }">
        <span class="glicon-check-circle"></span>
        <span>{{ $t(successNotification.message) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'NotificationBar',
  computed: {
    ...mapState({
      successNotification: (state) => state.notifications.successNotification,
      errorNotification: (state) => state.notifications.errorNotification
    })
  },
  methods: {
    close() {
      this.$store.dispatch('removeErrorNotification');
    }
  }
};
</script>

<style scoped>
.notification-icon {
  font-weight: bold;
  color: #2e3440;
  cursor: pointer;
}
</style>
